import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";

/** Debounced search input. Calls onChange after 300ms of inactivity. */
export default function SearchBox({
  value, onChange, placeholder = "Search…", testId = "search-box", debounceMs = 300,
}) {
  const [local, setLocal] = useState(value || "");
  useEffect(() => { setLocal(value || ""); }, [value]);
  useEffect(() => {
    const id = setTimeout(() => {
      if (local !== value) onChange(local);
    }, debounceMs);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local]);

  return (
    <div className="relative flex items-center w-full max-w-md">
      <Search className="absolute left-3 w-4 h-4 text-brand-muted pointer-events-none" />
      <input
        data-testid={testId}
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-9 pr-9 py-2 border border-brand-linen bg-white text-sm focus:outline-none focus:ring-1 focus:ring-brand-teal"
      />
      {local && (
        <button
          data-testid={`${testId}-clear`}
          onClick={() => { setLocal(""); onChange(""); }}
          className="absolute right-2 p-1 text-brand-muted hover:text-brand-ink"
          aria-label="Clear search"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
